export const EMPLOYEE_ROLE = 'PORTAL EMPLEADOS';
